// Token management
export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

// Headers for API requests
export const getAuthHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : ''
  };
};

// Check if the user is authenticated
export const isAuthenticated = () => {
  return !!getToken();
};

// Authenticated fetch wrapper
export const authFetch = (url, options = {}) => {
  const token = getToken();
  const headers = {
    ...options.headers,
    'Authorization': token ? `Bearer ${token}` : ''
  };
  
  return fetch(url, {
    ...options,
    headers
  });
};

// Get user role
export const getUserRole = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.role || null;
  } catch (error) {
    console.error('Errore nel recupero del ruolo utente:', error);
    return null;
  }
};

// Check if user has required role
export const hasRole = (requiredRole) => {
  const role = getUserRole();
  if (!role) return false;
  
  // Admin ha tutti i permessi
  if (role === 'admin') return true;
  
  // Altrimenti verifica il ruolo specifico
  return role === requiredRole;
}; 